import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Certificate from './certificate';
import { certificateDetails } from '../api';
import constants from "../constants";
import ProjectSection from "./projects";
import ToolsSection from "./tools-section";
import toastService from "../toast";

const App = () => {
    const [certificateData, setCertificateData] = useState({
        collegeName: '',
        courseName: '',
        valid: false,
        projects: [],
        tools: [],
        createdOn: new Date(),
        _id: ''
    });

    const { id } = useParams();
    const fetchData = async () => {
        try {
            console.log('API')
            const response = await certificateDetails(id);
            console.log('DATA', response.data)
            if (response.data.status === "success") {
                const data = response.data?.data
                setCertificateData(state => ({ 
                    ...state,
                    valid: true,
                    projects: data?.projects,
                    tools: data?.tools,
                    courseName: data?.courseName,
                    createdOn: new Date(data?.createdOn), 
                    _id: data?._id
                }))
            } else {
                setCertificateData(state => ({ ...state, valid: false }))
                toastService.error('Invalid Certificate Id')
            }
        } catch (err) {
            console.log({ err })
            setCertificateData(state => ({ ...state, valid: false }))
            toastService.error('Invalid Certificate Id')
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        if(id) fetchData();
    }, []);

    const downloadCertificate = async(imageSrc) => {
        const image = await fetch(imageSrc)
        const imageBlog = await image.blob()
        const imageURL = URL.createObjectURL(imageBlog)
      
        const link = document.createElement('a')
        link.href = imageURL
        link.download = `Certificate`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    const renderValidCertificate = () => {
        if (certificateData.valid) {
            return (
                <React.Fragment>
                    <Certificate url={constants.baseURL + `/verify-certificate/image?user=${id}&course=${certificateData._id}`} />
                    <div className="certificate__act" >
                        <button
                            className="certificate__act--download"
                            onClick={() => {downloadCertificate(`${constants.baseURL + `/verify-certificate/image?user=${id}&course=${certificateData._id}`}`)}} >
                            <img src="/assets/certificate/download.png" alt="download" />
                            Download Certificate
                        </button>
                        <button className="certificate__act--download" onClick={() => window.open(`https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${certificateData.courseName.replaceAll(' ', '%20')}&organizationId=${13684488}&issueYear=${certificateData.createdOn.getFullYear()}&issueMonth=${certificateData.createdOn.getMonth()}&certUrl=${`https://businesstoys.in/certificate/%23/${id}`}`, '__blank')} >
                            Add to LinkedIn &nbsp;<img src="https://learn.businesstoys.in/assets/free-course/linkedin.png" alt="linkedin" />
                        </button>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    };

    return (
        <section className="certificate" >
            <div className="certificate__nav" >
                <a href="https://businesstoys.in" target="__blank" >
                    <img
                        src='https://businesstoys.in/assets/global/business-toys-main.png'
                        alt="business toys logo" />
                </a>
            </div>
            {
                certificateData.valid ?
                    <h1>
                        Business Toys Skills School acknowledges the following accomplishment
                    </h1>
                    :
                    <h1 className="certificate">
                        Invalid Certificate Id
                    </h1>}
            {renderValidCertificate()}
            {certificateData.valid && <ToolsSection tools={certificateData.tools} />}
            {certificateData.valid && <ProjectSection projects={certificateData.projects} />}
            {
                certificateData.valid &&
                (<div className="certificate--c">
                <img src="/assets/certificate/imageOne.png"  alt="logo"/>
                <p>
                    The student has successfully completed all assigned projects with exceptional proficiency, demonstrating mastery in every aspect.
                </p>
                </div>)
            }
        </section>
    );
};

export default App;
